import axios from 'axios'
import { loadingService } from '@/utils/loadingService'
import { toastService } from '@/utils/toastService'
import i18n from '@/i18n'
import store from '@/store'
import { localeToRegionIdMap, uniteTenementId, errorCodeMap } from '@/config/const'

const makeErrorMessage = (errorCode) => {
  const errorMessage = errorCodeMap[errorCode]
  if (!errorMessage) {
    return i18n.global.t('api.serverError') + errorCode
  }
  return i18n.global.t(errorMessage)
}
// 开发环境使用代理路径，生产环境使用完整 URL
const baseURL = process.env.VUE_APP_ENV === 'dev' 
  ? '/actApi'  // 开发环境：走代理
  : process.env.VUE_APP_ACT_URL
const instance = axios.create({
  baseURL: baseURL,
})

instance.interceptors.request.use(config => {
  const locale = store.state.locale
  const { method, data = {}, params = {}, headers = {} } = config
  const token = store.state.cpUserInfo.token
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }
  const baseParams = {
    regionId: localeToRegionIdMap[locale],
    uniteTenementId
  }
  console.log(baseParams, 'baseParams')
  if (method === 'post') {
    const mergeParams = {
      ...baseParams,
      ...data
    }
    config.data = mergeParams
  } else if (method === 'get') {
    const mergeParams = {
      ...baseParams,
      ...params
    }
    config.params = mergeParams
  }
  let hasLoading = true
  if (config?.data?._loading === 0 || config?.params?._loading === 0) {
    hasLoading = false
  }
  if (hasLoading) {
    loadingService.show()
  }
  return config
}, error => {
  if (location.href.includes('mwr2025')) {
    toastService.showSmall('request error')

  } else {
    toastService.show('request error')
  }
  loadingService.hide()
  return Promise.reject(error)
})

instance.interceptors.response.use(response => {
  let hasLoading = true
  if (response.config.method === 'get' && response.config.params?._loading === 0) {
    hasLoading = false
  } else if (response.config.method === 'post' && response.config.data?._loading === 0) {
    hasLoading = false
  }
  if (hasLoading) {
    loadingService.hide()
  }
  if (response.status === 200) {
    if (response.data.code === 0) {
      return response.data.data
    } else {
      if (location.href.includes('mwr2025')) {
        toastService.showSmall(makeErrorMessage(response.data.code))
      } else {
        toastService.show(makeErrorMessage(response.data.code))
      }
      return Promise.reject(response.data)
    }
  } else {
    if (location.href.includes('mwr2025')) {
      toastService.showSmall(i18n.global.t('api.networkError'))
    } else {
      toastService.show(i18n.global.t('api.networkError'))
    }
    return Promise.reject(response.data)
  }
}, error => {
  if (location.href.includes('mwr2025')) {
    toastService.showSmall(i18n.global.t('api.networkError'))
  } else {
    toastService.show(i18n.global.t('api.networkError'))
  }
  loadingService.hide()
  return Promise.reject(error)
})

export default instance
